import Dexie from "dexie";
import db from "../Db";

var UpdateConcess = Dexie.async(function* (CONCESS) {
  yield db.open();
  yield db.CONCESS.put(CONCESS);
});

export default UpdateConcess;
